import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import NotFound from "./pages/NotFound";
import Services from "./pages/services";
import Growth from "./pages/growth";
import Partners from "./pages/partners";
import About from "./pages/about";
import CaseStudies from "./pages/case-studies";
import Homepage from "./pages/homepage";
import HardwarePricing from "./pages/instant-it-qoute";
import Products from "./pages/products";

const Routes = () => {

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Define your route here */}
          <Route path="/" element={<Homepage />} />
          <Route path="/services" element={<Services />} />
          <Route path="/growth" element={<Growth />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/about" element={<About />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/instant-it-quote" element={<HardwarePricing />} />
          <Route path="/products" element={<Products />} />
          <Route path="*" element={<NotFound />} />

        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
